import { Api } from 'models/services/api';
import { DeleteBusinessQuery } from 'models/services/graphql';

import { BusinessData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteBusiness($id: ID!) {
    ${DeleteBusinessQuery}
  }
`;

type ResponseData = {
  data: {
    deleteBusiness: BusinessData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: BusinessData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.deleteBusiness;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };